export default __webpack_public_path__ + "static/media/upload.0ca63d07.gif";